import React, { ReactNode } from 'react';
import { TransactionContext } from '../../contexts/TransactionContext/TransactionContext';
import { useTransactions } from '../../hooks/useTransactions/useTransactions';

interface TransactionsProviderProps {
  children: ReactNode;
}

export const TransactionsProvider = ({ children }: TransactionsProviderProps) => {
  const transactionsContextData = useTransactions();
  return (
    <TransactionContext.Provider value={transactionsContextData}>
      {children}
    </TransactionContext.Provider>
  );
}
